var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/schema/schema.ts
import { hasFeature } from "@precert/has-feature";
import { startOfDay, endOfDay } from "date-fns";
import isEmail from "validator/lib/isEmail";
import * as yup from "yup";

// src/schema/lookups.ts
var lookups_exports = {};
__export(lookups_exports, {
  BodyLocation: () => BodyLocation,
  GenderOptions: () => GenderOptions,
  PlacesOfService: () => PlacesOfService,
  ProviderType: () => ProviderType,
  QuantityTypes: () => QuantityTypes,
  ServiceTypes: () => ServiceTypes,
  SpecialTaxonomy: () => SpecialTaxonomy,
  arrayKeys: () => arrayKeys,
  arrayValues: () => arrayValues,
  fileTypes: () => fileTypes
});
function arrayValues(optionsObject) {
  const options = Object.entries(optionsObject).map(([, v]) => v);
  return options;
}
function arrayKeys(optionsObject) {
  const options = Object.entries(optionsObject).map(([k]) => k);
  return options;
}
var BodyLocation = {
  left: "Left",
  right: "Right",
  bilateral: "Bilateral"
};
var QuantityTypes = {
  DY: "Days",
  FL: "Units",
  HS: "Hours",
  MN: "Month",
  VS: "Visits"
};
var GenderOptions = {
  Male: "Male",
  Female: "Female",
  Unknown: "Unknown"
};
var ServiceTypes = {
  "2": "Surgical",
  "4": "Diagnostic X-Ray",
  "5": "Diagnostic Lab",
  "6": "Radiation Therapy",
  "7": "Anesthesia",
  "14": "Renal Supplies in the Home",
  "16": "Chronic Renal Disease (CRD) Equipment",
  "46": "Respite Care",
  "62": "MRI/CAT Scan",
  "63": "Donor Procedures",
  "66": "Pathology",
  "70": "Transplants",
  "73": "Diagnostic Medical",
  "76": "Dialysis",
  "78": "Chemotherapy",
  "87": "Cancer",
  "88": "Pharmacy",
  "93": "Podiatry",
  AD: "Occupational Therapy",
  AE: "Physical Medicine",
  BF: "Pulmonary Rehabilitation",
  BG: "Cardiac Rehabilitation",
  BL: "Cardiac",
  BN: "Gastrointestinal",
  BP: "Endocrine",
  BQ: "Neurology",
  BS: "Invasive Procedures",
  C1: "Coronary Care",
  ON: "Oncology"
};
var PlacesOfService = {
  "05": "Indian Health Service. Free-standing Facility",
  "06": "Indian Health Service. Provider-based Facility",
  "07": "Tribal 638. Free-standing Facility",
  "08": "Tribal 638. Provider-based Facility",
  "15": "Mobile Unit",
  "19": "Off Campus-Outpatient Hospital",
  "21": "Inpatient Hospital",
  "23": "Emergency Room \u2013 Hospital",
  "26": "Military Treatment Facility",
  "31": "Skilled Nursing Facility",
  "32": "Nursing Facility",
  "49": "Independent Clinic",
  "50": "Federally Qualified Health Center",
  "61": "Comprehensive Inpatient Rehabilitation Facility",
  "62": "Comprehensive Outpatient Rehabilitation Facility",
  "65": "End-Stage Renal Disease Treatment Facility",
  "71": "Public Health Clinic",
  "72": "Rural Health Clinic",
  "81": "Independent Laboratory",
  "99": "Other Place of Service"
};
var SpecialTaxonomy = {
  "01": "General Practice",
  "02": "General Surgery",
  "03": "Allergy Immunology",
  "04": "Otolaryngology",
  "05": "Anesthesiology",
  "06": "Cardiology",
  "07": "Dermatology",
  "08": "Family Practice",
  "09": "Interventional Pain Management",
  "10": "Gastroenterology",
  "11": "Internal Medicine",
  "12": "Osteopathic Manipulative Therapy (OMM)",
  "13": "Neurology",
  "14": "Neurosurgery",
  "16": "Obstetrics Gynecology",
  "18": "Ophthalmology",
  "19": "Oral Surgery (dental only)",
  "20": "Orthopedic Surgery",
  "22": "Pathology",
  "24": "Plastic and Reconstructive Surgery",
  "25": "Physical Medicine and Rehabilitation",
  "26": "Psychiatry",
  "28": "Colorectal Surgery (formerly Proctology)",
  "29": "Pulmonary Disease",
  "30": "Diagnostic Radiology",
  "32": "Anesthesiologist Assistant",
  "33": "Thoracic Surgery",
  "34": "Urology",
  "35": "Chiropractic",
  "36": "Nuclear Medicine",
  "37": "Pediatric Medicine",
  "38": "Geriatric Medicine",
  "39": "Nephrology",
  "40": "Hand Surgery",
  "41": "Optometry",
  "42": "Certified Nurse Midwife",
  "43": "Certified Registered Nurse Assistant (CRNA)",
  "44": "Infectious Disease",
  "45": "Mammography Screening Center",
  "46": "Endocrinology",
  "47": "Independent Diagnostic Testing Facility",
  "48": "Podiatry",
  "49": "Ambulatory Surgical Center",
  "50": "Nurse Practitioner",
  "51": "Medical Supply Company with Orthotist",
  "52": "Medical Supply Company with Prosthetist",
  "53": "Medical Supply Company with Orthotist-Prosthetist",
  "54": "Other Medical Supply Company",
  "55": "Individual Certified Orthotist",
  "56": "Individual Certified Prosthetist",
  "57": "Individual Certified Prosthetist-Orthotist",
  "58": "Medical Supply Company with Pharmacist",
  "59": "Ambulance Service Provider",
  "60": "Public Health or Welfare Agency",
  "61": "Voluntary Health or Charitable Agency",
  "62": "Psychologist",
  "63": "Portable X-Ray Supplier",
  "64": "Audiologist",
  "65": "Physical Therapist",
  "66": "Rheumatology",
  "67": "Occupational Therapist",
  "68": "Clinical Psychologist",
  "69": "Clinical Laboratory",
  "70": "Multi-specialty Clinic or Group Practice/single specialty",
  "71": "Registered Dietitian/Nutrition Professional",
  "72": "Pain Management",
  "73": "Mass Immunization Roster Billers",
  "74": "Radiation Therapy Center",
  "75": "Slide Preparation Facilities",
  "76": "Peripheral Vascular Disease",
  "77": "Vascular Surgery",
  "78": "Cardiac Surgery",
  "79": "Addiction Medicine",
  "80": "Licensed Clinical Social Worker",
  "81": "Critical Care (Intensivists)",
  "82": "Hematology",
  "83": "Hematology/Oncology",
  "84": "Preventive Medicine",
  "85": "Maxillofacial Surgery",
  "86": "Neuropsychiatry",
  "87": "All Other Suppliers",
  "88": "Unknown Supplier/Provider Specialty",
  "89": "Certified Clinical Nurse Specialist",
  "90": "Medical Oncology",
  "91": "Surgical Oncology",
  "92": "Radiation Oncology",
  "93": "Emergency Medicine",
  "94": "Interventional Radiology",
  "96": "Optician",
  "97": "Physician Assistant",
  "98": "Gynecological/Oncology",
  "99": "Unknown Physician Specialty",
  A0: "Hospital",
  A1: "Skilled Nursing Facility",
  A2: "Intermediate Care Nursing Facility",
  A3: "Other Nursing Facility",
  A4: "Home Health Agency",
  A5: "Pharmacy",
  A6: "Medical Supply Company with Respiratory Therapist",
  A7: "Department Store",
  A8: "Grocery Store"
};
var ProviderType = {
  AD: "Admitting",
  AS: "Assistant Surgeon",
  AT: "Attending",
  CO: "Consulting",
  CV: "Covering",
  OP: "Operating",
  OR: "Ordering",
  OT: "Other Physician",
  PC: "Primary Care Physician",
  PE: "Performing",
  RF: "Referring"
};
var fileTypes = ["TIF", "JPG", "JPEG", "PDF"];

// src/schema/schema.ts
var phoneRegex = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
var nameRegex = /^[a-z-. ]*$/i;
var nameRegexMessage = (fieldName) => `${fieldName} can only contain letters, dashes, periods and spaces`;
var diagnosisCodeRegex = /^[a-z0-9.\s]+$/i;
var diagnosisCodeErrorMessage = "This field can only contain letters, numbers, spaces, or decimals.";
var attachmentsErrorMessage = "At least one clinical document is required.";
var serviceTypesValues = arrayValues(ServiceTypes);
var serviceTypesKeys = arrayKeys(ServiceTypes);
var placeOfServiceValues = arrayValues(PlacesOfService);
var placeOfServiceKeys = arrayKeys(PlacesOfService);
var specialTaxonomyValues = arrayValues(SpecialTaxonomy);
var specialTaxonomyKeys = arrayKeys(SpecialTaxonomy);
var providerTypeValues = arrayValues(ProviderType);
var providerTypeKeys = arrayKeys(ProviderType);
var quantityTypeValues = arrayValues(QuantityTypes);
var quantityTypeKeys = arrayKeys(QuantityTypes);
var FormSchema = () => yup.object().shape(
  {
    veteranReferralId: yup.string().matches(
      /^VA\d{10}$/i,
      "Veteran Referral ID must be formatted as: VA followed by 10 digits"
    ).required("Veteran Referral ID number is required"),
    veteranIcn: yup.string().matches(
      /^\d{10}V\d{6}$/i,
      "Veteran ICN must be in format: 10 digits, V, 6 digits"
    ).required("Veteran ICN is required"),
    procedureCode: yup.string().when(["$features"], ([features], schema) => {
      return hasFeature("procedure-codes-list", features) ? schema.notRequired() : schema.required("Procedure Code is required").matches(/^[a-zA-Z0-9]+$/, "Procedure Code must be alphanumeric").length(5, "Procedure Code must be exactly 5 characters");
    }),
    procedureCodesList: yup.array().when(["$features"], ([features], schema) => {
      return hasFeature("procedure-codes-list", features) ? schema.required("Procedure Code(s) is required").max(
        12,
        "Procedure Code(s) cannot contain more than 12 entries"
      ).min(1, "Procedure Code(s) is required").of(
        yup.string().required("Procedure Code is required").matches(
          /^[a-zA-Z0-9]+$/,
          "Procedure Code must be alphanumeric"
        ).length(5, "Procedure Code must be exactly 5 characters")
      ) : schema.notRequired();
    }),
    hsrmVeteranLastName: yup.string().required("HSRM Veteran Last Name is required"),
    hsrmVeteranFirstName: yup.string().optional(),
    hsrmVeteranMiddleName: yup.string().optional(),
    hsrmVeteranSsn: yup.string().optional(),
    ohiInformation: yup.array().optional(),
    stationId: yup.string().required("Station ID is required"),
    referringFacility: yup.string().required("Referring facility is required"),
    seocName: yup.string().required("SEOC Name number is required"),
    seocId: yup.string().required("SEOC ID number is required"),
    seocVersionNumber: yup.string().required("SEOC Version Number is required"),
    hsrmVeteranIcn: yup.string().required("HSRM Veteran ICN is required"),
    referralDate: yup.date().required("Referral Date is required"),
    referralExpirationDate: yup.date().required("Referral Expiration Date is required"),
    cpac: yup.string().required("CPAC is required"),
    visn: yup.string().required("VISN is required"),
    preAuthTaskStatus: yup.string().required("Pre Auth Task Status is required"),
    requestType: yup.string().required("Precertification Type is required").oneOf(["Outpatient", "Inpatient"]),
    episodicCare: yup.boolean().required("Episodic Care is required").oneOf([true, false]),
    veteranFirstName: yup.string().trim().matches(nameRegex, nameRegexMessage("First Name")).nullable(),
    veteranLastName: yup.string().trim().required("Last Name is required").matches(
      nameRegex,
      "Last Name can only contain letters, dashes, and spaces"
    ),
    veteranDob: yup.date().transform((value, _original, context) => {
      return context.isType(value) && value instanceof Date ? startOfDay(value) : value;
    }).max(endOfDay(/* @__PURE__ */ new Date()), "Date of Birth must be before today.").nullable().required("Date of Birth is required, format mm/dd/yyyy"),
    veteranGender: yup.string().oneOf(["Male", "Female", "Unknown"]).required("Gender is required"),
    providerNpi: yup.string().required("Provider NPI is required and needs to be 10 digits").matches(
      /^\d{10}$/,
      "Provider NPI cannot contain alpha characters and needs to be 10 digits"
    ),
    providerName: yup.string().required("Provider Name is required"),
    providerType: yup.string().optional().oneOf(providerTypeValues),
    providerTypeCode: yup.string().optional().oneOf(providerTypeKeys),
    infusionCode: yup.string().trim().optional(),
    specialTaxonomy: yup.string().optional().oneOf(specialTaxonomyValues),
    specialTaxonomyCode: yup.string().optional().oneOf(specialTaxonomyKeys),
    facilityNpi: yup.string().required("Facility NPI is required and needs to be 10 digits").matches(
      /^\d{10}$/,
      "Facility NPI cannot contain alpha characters and needs to be 10 digits"
    ),
    facilityName: yup.string().required("Facility Name is required"),
    facilityAddress: yup.object().shape({
      street: yup.string().required("Address is required"),
      street2: yup.string().optional(),
      city: yup.string().required("City is required"),
      state: yup.string().required("State is required"),
      zip: yup.string().required("ZIP Code is required").matches(/^[0-9]{5}(-[0-9]{4})?$/, {
        message: "ZIP Code must be 5 or 9 digits",
        excludeEmptyString: true
      })
    }),
    providerEmail: yup.string().test(
      "is-email",
      "Email must be in the format: xxx@yyy.zzz",
      function(value) {
        return !value || isEmail(value);
      }
    ).optional(),
    serviceRender: yup.boolean().required("Service Render field is required").default(true),
    secondaryAddress: yup.object().when("serviceRender", {
      is: true,
      then: (schema) => schema.optional(),
      otherwise: () => yup.object().shape({
        street: yup.string().required("Address is required"),
        street2: yup.string().optional(),
        city: yup.string().required("City is required"),
        state: yup.string().required("State is required"),
        zip: yup.string().required("ZIP Code is required").matches(/^[0-9]{5}(-[0-9]{4})?$/, {
          message: "ZIP Code must be 5 or 9 digits",
          excludeEmptyString: true
        })
      })
    }),
    pointOfContactFirstName: yup.string().trim().nullable().matches(
      nameRegex,
      "First Name can only contain letters, dashes, periods and spaces"
    ),
    pointOfContactLastName: yup.string().trim().required("Last Name is required").matches(
      nameRegex,
      "Last Name can only contain letters, dashes, periods and spaces"
    ),
    pointOfContactPhone: yup.string().required("Phone must be in the format: NNN-NNN-NNNN").matches(phoneRegex, {
      message: "Phone must be in the format: NNN-NNN-NNNN",
      excludeEmptyString: true
    }),
    pointOfContactFax: yup.string().notRequired().matches(phoneRegex, {
      message: "Fax must be in the format: NNN-NNN-NNNN",
      excludeEmptyString: true
    }),
    pointOfContactEmail: yup.string().when(["$features"], ([features], schema) => {
      return hasFeature("alt-poc", features) ? schema.required("Email is required") : schema.notRequired();
    }).test(
      "is-email",
      "Email must be in the format: xxx@yyy.zzz",
      function(value) {
        return !value || isEmail(value);
      }
    ),
    hasAlternatePointOfContact: yup.boolean().required().default(false),
    alternatePointOfContactFirstName: yup.string().trim().nullable().matches(
      nameRegex,
      "First Name can only contain letters, dashes, periods and spaces"
    ),
    alternatePointOfContactLastName: yup.string().trim().when(
      ["$features", "hasAlternatePointOfContact"],
      ([features, hasAlternatePointOfContact], schema) => {
        return hasFeature("alt-poc", features) && hasAlternatePointOfContact ? schema.required("Last Name is required") : schema;
      }
    ).matches(
      nameRegex,
      "Last Name can only contain letters, dashes, periods and spaces"
    ),
    alternatePointOfContactPhone: yup.string().when(
      ["$features", "hasAlternatePointOfContact"],
      ([features, hasAlternatePointOfContact], schema) => {
        return hasFeature("alt-poc", features) && hasAlternatePointOfContact ? schema.required("Phone must be in the format: NNN-NNN-NNNN") : schema;
      }
    ).matches(phoneRegex, {
      message: "Phone must be in the format: NNN-NNN-NNNN",
      excludeEmptyString: true
    }),
    alternatePointOfContactFax: yup.string().matches(phoneRegex, {
      message: "Fax must be in the format: NNN-NNN-NNNN",
      excludeEmptyString: true
    }),
    alternatePointOfContactEmail: yup.string().when(
      ["$features", "hasAlternatePointOfContact"],
      ([features, hasAlternatePointOfContact], schema) => {
        return hasFeature("alt-poc", features) && hasAlternatePointOfContact ? schema.required("Email is required") : schema;
      }
    ).test(
      "is-email",
      "Email must be in the format: xxx@yyy.zzz",
      function(value) {
        return !value || isEmail(value);
      }
    ),
    diagnosisCodes: yup.array().default([]).of(
      yup.string().required("Diagnosis Code cannot be empty").matches(diagnosisCodeRegex, diagnosisCodeErrorMessage).test("Duplicate", "Duplicate code found", (value, props) => {
        const test = props.parent?.filter((m) => m === value);
        if (test?.length > 1) return false;
        return true;
      })
    ).max(12, "Diagnosis Codes cannot contain more than 12 entires").when("primaryDiagnosis", {
      is: (primaryDiagnosis) => primaryDiagnosis,
      then: (schema) => schema.nullable(),
      otherwise: (schema) => schema.min(1, "Diagnosis Codes is required")
    }),
    primaryDiagnosis: yup.string().when("diagnosisCodes", {
      is: (diagnosisCodes) => diagnosisCodes?.length >= 1,
      then: (schema) => schema.nullable(),
      otherwise: (schema) => schema.required("Primary Diagnosis is required")
    }),
    secondaryDiagnosis: yup.array().of(
      yup.string().required("A secondary diagnosis code cannot be empty").test("Duplicate", "Duplicate code found", (value, props) => {
        const test = props.parent?.filter((m) => m === value);
        if (test?.length > 1) return false;
        return true;
      }).test(
        "Duplicate Primary",
        "One of these codes has the same value in the primary diagnosis field",
        (value, props) => {
          const test = props.parent?.filter(
            (m) => m === props.from[0].value.primaryDiagnosis
          );
          if (test?.length >= 1) return false;
          return true;
        }
      )
    ).max(11, "Secondary Diagnosis cannot contain more than 11 entires"),
    bodyLocation: yup.string().oneOf(["Left", "Right", "Bilateral"]),
    quantity: yup.number().integer("Quantity must be a whole number").required("Quantity is required").min(1, "Quantity must be a positive number").typeError("Quantity must be a number"),
    quantityType: yup.string().oneOf(quantityTypeValues).required("Quantity Type is required"),
    quantityTypeCode: yup.string().oneOf(quantityTypeKeys).required("Quantity Type Code is required"),
    placeOfService: yup.string().oneOf(placeOfServiceValues).required("Place Of Service is required"),
    placeOfServiceCode: yup.string().oneOf(placeOfServiceKeys).required("Place Of Service Code is required"),
    dateOfService: yup.date().required("Date Of Service is required, format mm/dd/yyyy"),
    serviceType: yup.string().when("requestType", ([requestType], schema) => {
      return requestType === "Inpatient" ? schema.oneOf(serviceTypesValues).required("Service Type is required") : schema;
    }),
    serviceTypeCode: yup.string().when("requestType", ([requestType], schema) => {
      return requestType === "Inpatient" ? schema.oneOf(serviceTypesKeys).required("Service Type Code is required") : schema;
    }),
    attachments: yup.array().required(attachmentsErrorMessage).min(1, attachmentsErrorMessage).of(
      yup.object().shape({
        uploaded: yup.boolean(),
        fileName: yup.string().required("File name is required"),
        contentType: yup.string().required("Content Type is required"),
        contentLength: yup.number().required("Content Length is required"),
        attachmentId: yup.string().required("Attachment ID is required")
      })
    ),
    clinicalNotes: yup.string()
  },
  // EXPLANATION: https://github.com/jquense/yup/issues/720
  [["diagnosisCodes", "primaryDiagnosis"]]
);

// src/schema-validator-yup.ts
import { ValidationError } from "yup";
var schema_validator_yup_default = (schema) => {
  function validate(o, context, propertyPath) {
    try {
      if (propertyPath) {
        schema.validateSyncAt(propertyPath, o, { abortEarly: false, context });
      } else {
        schema.validateSync(o, { abortEarly: false, context });
      }
      return [true, []];
    } catch (error) {
      if (error instanceof ValidationError) return [false, error.errors];
      return [false, [`${error}`]];
    }
  }
  validate.schema = schema;
  return validate;
};
export {
  FormSchema,
  lookups_exports as Lookups,
  schema_validator_yup_default as Validator,
  diagnosisCodeErrorMessage
};
